var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 0.916992C5.43109 0.916992 0.916504 5.43158 0.916504 11.0003C0.916504 16.5691 5.43109 21.0837 10.9998 21.0837C16.5686 21.0837 21.0832 16.5691 21.0832 11.0003C21.0832 5.43158 16.5686 0.916992 10.9998 0.916992ZM11.9165 14.667C11.9165 14.9101 11.8199 15.1433 11.648 15.3152C11.4761 15.4871 11.243 15.5837 10.9998 15.5837C10.7567 15.5837 10.5236 15.4871 10.3517 15.3152C10.1797 15.1433 10.0832 14.9101 10.0832 14.667V11.917H7.33317C7.09006 11.917 6.8569 11.8204 6.68499 11.6485C6.51308 11.4766 6.4165 11.2434 6.4165 11.0003C6.4165 10.7572 6.51308 10.5241 6.68499 10.3521C6.8569 10.1802 7.09006 10.0837 7.33317 10.0837H10.0832V7.33366C10.0832 7.09054 10.1797 6.85739 10.3517 6.68548C10.5236 6.51357 10.7567 6.41699 10.9998 6.41699C11.243 6.41699 11.4761 6.51357 11.648 6.68548C11.8199 6.85739 11.9165 7.09054 11.9165 7.33366V10.0837H14.6665C14.9096 10.0837 15.1428 10.1802 15.3147 10.3521C15.4866 10.5241 15.5832 10.7572 15.5832 11.0003C15.5832 11.2434 15.4866 11.4766 15.3147 11.6485C15.1428 11.8204 14.9096 11.917 14.6665 11.917H11.9165V14.667Z",
    fill: "#A5A7B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.fed9e622cf8afa89d608db969358d314.svg";
export { ForwardRef as ReactComponent };